<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial" :searchBtnHide="!!$store.getters.cusId" :resetBtnHide="!!$store.getters.cusId"
        :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm v-if="!$store.getters.cusId">
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="clientCode">
              <BjSelectLov v-model="queryParams.clientCode" :clearable="false" :option-list="clientCodeList" :placeholder="$t('billingPage.CustomerName')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('table.createTimeText')" prop="creationDate">
              <BjDateRangePicker v-model="dataTime" :placeholder="$t('table.createTimeText')" value-format="yyyy-MM-dd HH:mm:ss" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
              <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                  <template slot-scope="scope">
                      <template v-if="false" />
                      <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                  </template>
              </el-table-column>
              <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" class="edit-btn" @click="onDetail(scope.row)">{{ $t('viewText')}}</el-button>
                      <el-button type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
                      <!-- <el-button type="text" class="edit-btn" @click="onDelete(scope.row)">{{ $t('delText')}}</el-button> -->
                  </template>
              </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>

  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { funConfigApi } from '@/api';
  import { STATUS_ENABLED_NUM } from '@/utils/constants';
  export default {
      name: 'BusinessUserfunConfig',
      mixins: [pageMiXin],
      data() {
          return {
              queryApi: funConfigApi.getConfigurationList,
              // 查询参数
              queryParams: {
                  clientCode: this.$store.getters.userInfo.clientCode || null,
                  startCreationDate: '',
                  endLastUpdateDate: '',
              },
              labelList: [
                  { label: this.$t('customerNameText'), prop: 'loginName', isCheck: true, disabled: false },
                  { label: this.$t('AccountManagement.customer.companyName'), prop: 'companyName', isCheck: true, disabled: false },
                  { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false },
                  { label: this.$t('BusinessPurchaseSupplierShop.table.updateDate'), prop: 'lastUpdateDate', isCheck: true, disabled: false },
                  { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
              ],
              STATUS_ENABLED_NUM,
              dataTime: [],
          };
      },
      watch: {
        dataTime(v){
            this.queryParams.startCreationDate = (v || [])[0];
            this.queryParams.endLastUpdateDate = (v || [])[1];
        }
      },
      methods: {
          beforeResetSearch() {
              this.dataTime = [];
              this.queryParams.startCreationDate = null;
              this.queryParams.endLastUpdateDate = null;
              return new Promise(resolve => {
                  resolve();
              });
          },
          //   新增
          onAdd() {
              this.$router.push({
                  name: 'BusinessUserfunConfigInfo'
              })
          },
          onDetail(row) {
              this.$toPage('BusinessUserfunConfigInfo', {
                userId: row.userId,
                clientCode: row.clientCode,
                isSee: true
              })
          },
          onEdit(row) {
              this.$toPage('BusinessUserfunConfigInfo', {
                userId: row.userId,
                clientCode: row.clientCode
              })
          },
          onDelete(row) {
            this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
              confirmButtonText: this.$t('toast.okText'),
              cancelButtonText: this.$t('toast.cancelText'),
              type: 'warning',
            }).then(() => {
              funConfigApi.deleteConfig({
                userId: row.userId,
                clientCode: row.clientCode
              }).then(res => {
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.reFresh()
                }
              })
            })
          },
      },
  };
  </script>
  
  <style scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>